import React, { useState, useEffect } from "react";
import Video from "../../videos/video.mp4";
import {
  CoverContainer,
  CoverBg,
  VideoBg,
  CoverContent,
  CoverH1,
  CoverP,
  CoverBtnWrapper,
  ArrowForward,
  ArrowRight,
} from "./CoverElements";
import { Button } from "../ButtonElements";
import "./style.css";
import { useTranslation } from "react-i18next";
import PropTypes from "prop-types";
const CoverSection = ({ isRTL }) => {
  const [hover, setHover] = useState(false);
  const { t } = useTranslation();
  const onHover = () => {
    setHover(!hover);
  };

  useEffect(() => {
    const handleVisibilityChange = () => {
      if (document.visibilityState === "visible") {
        setHover(false);
      }
    };
    document.addEventListener("visibilitychange", handleVisibilityChange);
    window.addEventListener("pageshow", (event) => {
      if (event.persisted) {
        setHover(false);
      }
    });

    return () => {
      document.removeEventListener("visibilitychange", handleVisibilityChange);
      window.removeEventListener("pageshow", handleVisibilityChange);
    };
  }, []);

  return (
    <CoverContainer className={isRTL ? "arabe" : ""}>
      <CoverBg>
        <VideoBg autoPlay loop muted src={Video} type="video/mp4" />
      </CoverBg>
      <CoverContent>
        <CoverH1>
          You <span className="green-c">C</span>li{""}
          <span className="green-c">C</span>
          <span className="white-You">You</span>
          <span className="green-c">C</span>laim
        </CoverH1>
        <CoverP>{t("cover.description")}</CoverP>
        <CoverBtnWrapper>
          <Button
            as="a"
            href="https://guest.cliclaim.com/"
            target="_blank"
            rel="noopener noreferrer"
            onMouseEnter={onHover}
            onMouseLeave={onHover}
            onBlur={() => setHover(false)}
            primary="true"
            dark="true"
          >
            {t("cover.btnLabel")} {hover ? <ArrowForward /> : <ArrowRight />}
          </Button>
        </CoverBtnWrapper>
      </CoverContent>
    </CoverContainer>
  );
};
CoverSection.propTypes = {
  isRTL: PropTypes.bool,
};
export default CoverSection;
